export default "__VITE_ASSET__DOpLr55s__"